import { useEffect, useRef } from 'react';
import { useSelector } from 'react-redux';
import axiosInstance from '../apiServices/axios';
import { getBrowserTimezone } from '../utils/tentTimezoneUtils';

const REPORT_TIMEZONE_URL = '/accounts/me/report-timezone/';

export const useBrowserTimezoneReport = (enabled = true) => {
    const { user } = useSelector(state => state.user);
    const reportedRef = useRef(false);

    useEffect(() => {
        if (!enabled || !user?.id || reportedRef.current) return;
        if (user.timezone_source === 'USER') return;

        const browserTz = getBrowserTimezone();
        if (!browserTz) return;

        reportedRef.current = true;
        axiosInstance
            .post(REPORT_TIMEZONE_URL, { timezone: browserTz })
            .catch(() => {
                reportedRef.current = false;
            });
    }, [enabled, user?.id, user?.timezone_source]);
};

export default useBrowserTimezoneReport;
